import React, { useCallback, useState } from 'react';
import css from './AdditionalServicePanelDetailMedia.module.scss';
import { Dialog } from '@framework-controls/core';
import { IconRemove } from 'src/content/icons';
import { VehicleRec, ascMediaInteractionInput, ascCtaInteractionInput, ascPageviewInput, ascElementConfigurationInput } from 'src/models';
import { ascMediaInteraction, ascCtaInteraction, ascPageview, ascElementConfiguration } from 'src/helpers/EventHelper/EventHelper';

export interface IProps {
    id: string;
    opDesc: string;
    opUrlType: string;
    opUrlLink: string;
    opUrlTrack: string;
    vehicles: VehicleRec[];
    selectedVehicle?: string;
}

const AdditionalServicePanelDetailMedia = (props: IProps) => {
    const [mediaOpen, setMediaOpen] = useState(false);
    const toggleMedia = useCallback((e: any) => {
        if (mediaOpen) {
            const ascCtaInteractionInp : ascCtaInteractionInput = {
                pageType: 'service',
                elementText: '',
                elementColor: '',
                elementOrder: '',
                elementType: 'popup',
                elementSubType: 'informaiton_link',
                eventAction: 'click',
                eventActionResult: 'close',
                linkUrl: '',
            };
            ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
            const ascElementConfigurationInp: ascElementConfigurationInput = {
                pageType: 'service',
                elementText: '',
                elementType: 'popups',
                elementColor: '',
                eventAction: 'click',
                eventActionResult: 'close',
                linkUrl: '',
            };
            ascElementConfiguration(ascElementConfigurationInp, e);
        } else {
            const ascCtaInteractionInp : ascCtaInteractionInput = {
                pageType: 'service',
                elementText: props.opDesc,
                elementColor: '',
                elementOrder: '',
                elementType: 'popup',
                elementSubType: 'information_link',
                eventAction: 'click',
                eventActionResult: 'open',
                linkUrl: '',
            };
            ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
            const ascElementConfigurationInp: ascElementConfigurationInput = {
                pageType: 'service',
                elementText: props.opDesc,
                elementType: 'popup',
                elementColor: '',
                eventAction: 'click',
                eventActionResult: 'open',
                linkUrl: '',
            };
            ascElementConfiguration(ascElementConfigurationInp, e);
        }
        setMediaOpen(!mediaOpen);
    }, [mediaOpen, props.vehicles, props.selectedVehicle, props.opDesc]);

    const mediaClickHandler = useCallback((e: any, id: string) => {
        toggleMedia(e);
        let mediaType = '';
        if (id) {
            if (id?.slice(-3) === 'img') {
                mediaType = 'image';
            } else if (id?.slice(-3) === 'vid') {
                mediaType = 'video';
            }
        }
        if (!mediaOpen) {
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'service',
                errorCode: '',
                itemResults: '',
            };
            ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);
            const ascMediaInteractionInp : ascMediaInteractionInput = {
                pageType: 'service',
                eventActionResult: 'popup',
                affiliation: '',
                mediaType: mediaType,
                linkUrl: props.opUrlLink,
                creativeName: props.opDesc,
            };
            ascMediaInteraction(ascMediaInteractionInp, props.vehicles, props.selectedVehicle);
        }
    }, [props.opDesc, props.opUrlLink, props.vehicles, props.selectedVehicle, mediaOpen, toggleMedia]);

    let mediaDisplay: JSX.Element = <></>;
    if (props.opUrlType === 'I') {
        mediaDisplay = (
            <div className={css.mediaImage}>
                <img
                    src={props.opUrlLink}
                    alt={props.opDesc}
                    id={props.id + 'img'}
                    className={css.mediaDisplayImg}
                    onClick={(e: any) => mediaClickHandler(e, props.id + 'img')}
                />
            </div>
        );
    } else {
        mediaDisplay = (
            <div style={{ display: 'inline-flex' }}>
                <div className={css.mediaVideoPlusButton}>
                    <video id={props.id + 'vid'} className={css.mediaDisplayVideo} controls crossOrigin='anonymous'>
                        <source srcSet={props.opUrlLink} />
                        <track src={props.opUrlTrack} />
                    </video>
                    <button
                        id={props.id + 'vidBtn'}
                        className={css.videoOverlay}
                        onClick={(e: any) => mediaClickHandler(e, props.id+'vidBtn')}
                    ></button>
                </div>
            </div>
        );
    }

    return (
        <div className={css.mediaDisplayArea}>
            {mediaDisplay}
            <Dialog
                id='dialog'
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={mediaOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={''}
                hideSave={true}
                hideCancel={true}
                hideClose={true}
                // hideBackdrop={true}
                disableUpperCase={true}
                onCancel={toggleMedia}
                onBackDropClick={toggleMedia}
                width={'full'}
            >
                <div className={css.headerbox}>
                    {''}
                    <div className={css.headerIcon}>
                        <IconRemove id='closeBtn' onClick={toggleMedia}/>
                    </div>
                </div>
                {props.opUrlType === 'I' ?
                    <div
                        style={{ display: 'block'}}>
                        <img
                            src={props.opUrlLink}
                            alt={props.opDesc}
                            id={props.id + 'expanded'}
                            className={css.expandedMediaDisplayImg}
                        />
                    </div> :
                    <div
                        style={{ display: 'block' }}>
                        <video width={522} height={306} className={css.expandedMediaDisplayVideo} controls crossOrigin='anonymous'>
                            <source srcSet={props.opUrlLink} />
                            <track src={props.opUrlTrack} />
                        </video>
                    </div>
                }
            </Dialog>
        </div>
    );
};

export default AdditionalServicePanelDetailMedia;